import React, { createContext } from "react";
const VideoContext = createContext();
export default VideoContext;
